import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  isExternalAuth: boolean;
  setIsExternalAuth: (isExternalAuth: boolean) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isExternalAuth: false,
      setIsExternalAuth: (isExternalAuth: boolean) => set({ isExternalAuth }),
    }),
    {
      name: 'auth-store',
      partialize: (state) => ({ isExternalAuth: state.isExternalAuth }),
    },
  ),
);
